import { CustomTranslationWithoutFallback } from "./custom-translation-without-fallback";

export class CustomTranslation extends CustomTranslationWithoutFallback {
	public Fallback: string = "";

	constructor(data?: any) {
		super(data);
		if (!data) {
			return;
		}
		this.Fallback = data.Fallback;
	}

	public getTranslation(lang: string) {
		return this.Translations[lang] || this.Fallback;
	}

	public getTranslationWithoutFallback(lang: string) {
		return this.Translations[lang] || "";
	}

	public setText(text:string) {
		super.setText(text);
		this.Fallback = text;
	}

	private computeFallBack():string{
		let fallback = this.getTranslationWithoutFallback("nl-be");
		if (fallback) return fallback;
		if (Object.keys(this.Translations).length) {
			return "";
		}
		for (let key of Object.keys(this.Translations)){
			if (!this.Translations[key]) continue;
			return this.Translations[key];
		}
		return "";
	}

	public getJSON(): any {
		let obj = super.getJSON();
		let fallback = this.computeFallBack();
		return {
			...obj,
			Fallback: fallback
		};
	}

	public clone(): CustomTranslation {
		return new CustomTranslation(this.getJSON());
	}
}
